import { Directive, inject, input } from '@angular/core';
import { injectSupportsHoverInteraction } from '@quipex/core/utils';
import { injectPopoverWithHover } from '@quipex/shared/ui';
import { QuippyApi, isCanonicalDocumentId } from '../../../runtime';
import type { QuippySourceDocumentPopover } from './source-document-popover/source-document-popover';

@Directive({
    selector: '[qpxQuippySourceHover]',
    host: {
        'data-quippy-source-trigger': '',
        '(mouseenter)': 'onMouseEnter($event.currentTarget)',
        '(mouseleave)': 'popover.leaveTrigger($event.relatedTarget)',
        '(click)': 'popover.close()',
    },
})
export class QuippySourceHover {
    public readonly documentId = input<string | null>(null);
    public readonly buildingName = input<string | null>(null);
    public readonly buildingId = input<string | null>(null);
    private readonly api = inject(QuippyApi);
    private readonly supportsHover = injectSupportsHoverInteraction();
    protected readonly popover =
        injectPopoverWithHover<QuippySourceDocumentPopover>({
            isEnabled: () =>
                Boolean(this.buildingId()) &&
                isCanonicalDocumentId(this.documentId()),
            componentInputs: () => ({
                buildingName: this.buildingName(),
                buildingId: this.buildingId() ?? '',
                documentId: this.documentId() ?? '',
            }),
            providers: [{ provide: QuippyApi, useValue: this.api }],
            loadComponent: async () =>
                (
                    await import('./source-document-popover/source-document-popover')
                ).QuippySourceDocumentPopover,
            triggerSelector: '[data-quippy-source-trigger]',
            overlaySelector:
                '[data-quippy-source-popover], [aria-label="Additional source document metadata"]',
        });
    protected onMouseEnter(origin: EventTarget | null): void {
        if (this.supportsHover() && origin instanceof HTMLElement)
            this.popover.enterTrigger(origin);
    }
}
